<template>
  <div>
    <library-header />
    <library-banner v-if="displayBanner"/>
    <section class="library-content" :class="{'has-side-bar': displaySidebar }">
      <aside v-if="displaySidebar" class="content-approval-sidebar">
        <library-sidebar/>
      </aside>
      <filter-bar />
      <router-view />
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { sideBarData } from '@/constants'
import FilterBar from '@/components/filter-bar'
import LibraryHeader from '@/components/library-header'
import LibraryBanner from '@/components/library-banner'
import librarySidebar from '@/components/sidebar'

export default {
  name: 'base-library',
  components: { FilterBar, LibraryHeader, LibraryBanner, librarySidebar },
  data () {
    return {
      isSearchResult: false
    }
  },
  beforeMount () {
    if (this.$route.query.searchText) {
      this.$store.dispatch('setSearchWord', this.$route.query.searchText)
    }
    if (this.$route.query.filters) {
      const filtersTOAdd = []
      const arrayOfFilters = JSON.parse(this.$route.query.filters)
      for (const filter of arrayOfFilters) {
        filtersTOAdd.push(filter.split('-'))
      }
      this.$store.dispatch('setFilltersFromRouteAfterRefresh', filtersTOAdd)
    }
    if (this.$route.query.searchText || this.$route.query.filters) {
      this.$store.dispatch('getFilterCollectionEntries')
    }
  },
  created () {
    this.$store.dispatch('toggleBaseLibraryMenu', null)
  },
  computed: {
    ...mapState({
      userRoles: state => state.base.userRoles,
      user: state => state.base.user
    }),
    // banner is displayed if the email and permission from url are different from user signIn data
    displayBanner () {
      const bannerData = JSON.parse(localStorage.getItem('bannerData'))
      if ((bannerData?.email !== this.user?.email) && (bannerData && !this.userRoles?.includes(bannerData.permission))) {
        return true
      }
      return false
    },
    displaySidebar () {
      return this.userRoles?.some(role => sideBarData.visibleTo.includes(role))
    }
  }
}
</script>

<style lang="scss" scoped>
  .popup-position{
    position: absolute;
    width: 100vw;
    top: 0;
    left: 0;
    background: white;
  }
</style>
